import { useMutation, useQueryClient } from "react-query";
import authAPI from "../authAPI";

export const useToggleHiddenGroup = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ groupId }) => authAPI.toggleHiddenGroup(groupId),
    {
      onSuccess: (data, variables) => {
        // Invalidate group tree queries
        queryClient.invalidateQueries(["group"]);
        // Invalidate organizations
        queryClient.invalidateQueries(["organizations"]);
      },
      onError: (error) => {
        console.error("Error while toggling hidden group:", error);
      },
    }
  );
};
